import _get from 'lodash/get';
import _map from 'lodash/map';
import _keys from 'lodash/keys';
import _join from 'lodash/join';
import _isEmpty from 'lodash/isEmpty';
import _toLower from 'lodash/toLower';
import _startsWith from 'lodash/startsWith';
import { getBoxPositionOnWindowCenter } from './dimensionHelper';
import { AFITD_SHARE_URL, AFITD_DOMAIN, PATH_BRAND, PATH_TALENT, PATH_SUB_PAGE_EMP, PATH_SUB_PAGE_JOB, PATH_JOB_CENTER, PATH_SUB_PAGE_JOB_SEEKER } from '../system/constants';
import isURL from 'validator/lib/isURL';

const getShareText = () => `I'm sharing my profile with you from ${AFITD_DOMAIN}, please take a look.`;

export const objectToGetParams = object => {
    const params = Object.entries(object)
        .filter(([, value]) => value !== undefined && value !== null)
        .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`);

    return params.length > 0 ? `?${params.join('&')}` : '';
};

export const getTwitterShareLink = shareUrl => {
    const paramObj = {
        text: getShareText(),
        url: shareUrl,
    };
    return `https://twitter.com/intent/tweet${objectToGetParams(paramObj)}`;
};

export const getLinkedInShareLink = shareUrl => {
    const paramObj = {
        url: shareUrl,
    };
    return `https://www.linkedin.com/sharing/share-offsite/${objectToGetParams(paramObj)}`;
};

export const getPinterestShareLink = (shareUrl, shareMediaUrl) => {
    const paramObj = {
        url: shareUrl,
        media: shareMediaUrl,
    };
    return `http://pinterest.com/pin/create/link/${objectToGetParams(paramObj)}`;
    // return `https://www.pinterest.com/pin-builder/${objectToGetParams(paramObj)}`;
};

export const getFacebookShareLink = shareUrl => {
    const paramObj = {
        u: shareUrl,
    };
    return `https://www.facebook.com/sharer/sharer.php${objectToGetParams(paramObj)}`;
};

export const getShareWindowConfigStr = params => {
    const width = _get(params, 'width', 550);
    const height = _get(params, 'height', 650);
    const config = {
        width,
        height,
        ...getBoxPositionOnWindowCenter(width, height),
    };
    return _join(
        _map(_keys(config), key => `${key}=${config[key]}`),
        ', ',
    );
};

export const scrubUrl = urlToScrub => {
    if (!_isEmpty(urlToScrub)) {
        const lowerCaseUrlToScrub = _toLower(urlToScrub);
        if (lowerCaseUrlToScrub === 'https://' || lowerCaseUrlToScrub === 'http://') {
            return '';
        } else if (!_startsWith(lowerCaseUrlToScrub, 'https://') && !_startsWith(lowerCaseUrlToScrub, 'http://')) {
            return 'https://' + urlToScrub;
        }
    }
    return urlToScrub;
};

export const isValidUrl = (str, options) => {
    // const regexp =
    //     /^(?:(?:https):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/;
    // return regexp.test(str);

    const isUrlOptions = {
        protocols: ['https'],
        require_tld: true,
        require_protocol: true,
        require_host: true,
        require_port: false,
        require_valid_protocol: true,
        allow_underscores: false,
        host_whitelist: false,
        host_blacklist: false,
        allow_trailing_dot: false,
        allow_protocol_relative_urls: false,
        allow_fragments: true,
        allow_query_components: true,
        disallow_auth: false,
        validate_length: true,
        ...options,
    };

    if (str) return isURL(str, isUrlOptions);
    else return false;
};

export const hasHttps = str => {
    const regexp = /^(?:(?:https):\/\/)/;
    return regexp.test(str);
};

export const getHttpsUrl = str => {
    if (str) {
        return hasHttps(str) ? str : `https://${str}`;
    } else {
        return null;
    }
};

export const getEmployerShareUrl = ({ urlName, employerId } = {}) => {
    return urlName ? `https://${AFITD_SHARE_URL}${PATH_BRAND}/${urlName}` : `https://${AFITD_SHARE_URL}${PATH_BRAND}/${PATH_SUB_PAGE_EMP}/${employerId}`;
};

export const getJobSeekerShareUrl = ({ urlName, userId } = {}) => {
    return urlName ? `https://${AFITD_SHARE_URL}${PATH_TALENT}/${urlName}` : `https://${AFITD_SHARE_URL}${PATH_TALENT}/${PATH_SUB_PAGE_EMP}/${userId}`;
};

export const getEmpMyJobShareUrl = ({ jobId } = {}) => {
    // return `https://${AFITD_SHARE_URL}${PATH_DASHBOARD}/${DASHBOARD_ID_MY_JOBS}/${PATH_SUB_PAGE_JOB}/${jobId}`;
    return `https://${AFITD_SHARE_URL}${PATH_JOB_CENTER}/${PATH_SUB_PAGE_JOB}/${jobId}`;
};

export const getBrandPageUrlPathByEmployerId = employerId => {
    return `${PATH_BRAND}/${PATH_SUB_PAGE_EMP}/${employerId}`;
};

export const getTalentPageUrlPathById = talentId => {
    return `${PATH_TALENT}/${PATH_SUB_PAGE_JOB_SEEKER}/${talentId}`;
};

export const stopEventPropagation = evt => {
    if (evt) evt.stopPropagation();
};
